const Constants = {
  HH_COMPONENTS_URL: process.env.VUE_APP_HH_COMPONENTS_URL,
  ACCESS_DASHBOARD_URL: process.env.VUE_APP_ACCESS_DASHBOARD,
  COMPONENT_ENV: process.env.VUE_APP_COMPONENT_ENV,
  LANDING_PAGE_URL: process.env.VUE_APP_LANDING_PAGE_URL,
  NAMETAG_USER_VERIFICATION_URL: process.env.VUE_APP_NAMETAG_USER_VERIFICATION_URL,
  SERVICE_DESK_NUMBER: "+1 415 507 8888",
  USER_DATA_USAGE_CONSENT: `I understand that my biometric data will be processed with the sole purpose of verifying my identity 
  and agree that Autodesk share my personal data with Nametag for said purpose. I acknowledge that my data will be processed in 
  accordance with the <a href="/assets/pdf/Autodesk-Global-Worker-Data-Protection-Policy.pdf" class="link" download="Autodesk-Global-Worker-Data-Protection-Policy.pdf">
  Autodesk Global Worker Data Protection Policy </a>and that I can revoke my consent at any time by sending an e-mail to 
  <a href="mailto:enterprise.vc.support@autodesk.com" class="link">enterprise.vc.support@autodesk.com</a>`,
  APP_LIST: [
    {
      title: "Autodesk One",
      logo: require("@/assets/images/Autodesk_logo_circle.svg"),
      url: process.env.VUE_APP_AUTODESK_ONE,
      description: "Autodesk’s intranet with news and resources for workers"
    },
    {
      title: "Engineer's Home Page",
      logo: require("@/assets/images/EngineersHomepage.svg"),
      url: "https://engineering.autodesk.com",
      description: "The central connection point for the Autodesk Engineering community"
    },
    {
      title: "Worker Identity Verification",
      logo: require("@/assets/images/Password_management.svg"),
      fn: "launchIdentityWizard",
      description: "Verify your identity for password or MFA reset or if you are a new hire"
    },
    {
      title: "Password management",
      logo: require("@/assets/images/Password_management.svg"),
      fn: "openChangePwdModal",
      description: "Change, update, or reset your Autodesk password"
    },
    {
      title: "Two-step verification",
      logo: require("@/assets/images/Two-step_verification.svg"),
      url: process.env.VUE_APP_TWO_STEP_VERIFICATION,
      description: "Set up Microsoft Authenticator to access Autodesk applications"
    },
    {
      title: "Facilities request",
      logo: require("@/assets/images/Facilities_request.svg"),
      url: "https://autodesk.ops.bim360ops.com",
      description: "Submit a facilities request using BIM 360 Ops"
    },
    {
      title: "All applications",
      logo: require("@/assets/images/Autodesk_logo_circle.svg"),
      url: process.env.VUE_APP_ACCESS_DASHBOARD,
      description: "One place to serve all your application and access related needs"
    }
  ],
  WARNING_MESSAGES: {
    "Password_Reset": "Resetting your password will immediately sign you out of your account on all devices. You will not be able to access your account until your password reset is completed.",
    "MFA_Reset": "Resetting your MFA will immediately sign you out of your account on all devices. You will not be able to access your account until the new MFA registration is completed successfully.",
  },
  ERROR_MESSAGES: {
    "Nametag_Verification_In_Progress": "You still have remaining steps to complete in the Nametag app. Go to the app to continue",
    "Nametag_Verification_Failure": "Something went wrong and your identity was not verified. Please try again",
    "Retry_Limit_Exceeded": "Sorry, you’ve reached the maximum number of tries. Please call the Service Desk at +1 415 507 8888 to get help verifying your identity.",
    "Server_Error": "Something went wrong and your identity was not verified. Please try again. ",
    "isRestrictedRegion": "It looks like we don’t yet support this process for your location. Please call the Service Desk at +1 415 507 8888 to get help verifying your identity.",
    "isNewHire": "This step is only for new hires. Please call the Service Desk at +1 415 507 8888 to get help verifying your identity",
    "verifiedIn24hrs": "You’ve already verified your identity recently. If needed, you can verify again after 24 hours"
  }
};

export default Constants;